import { getField, updateField } from "vuex-map-fields";
// import TYPES from "@/store/modules/customer/types";

const getDefaultState = () => {
  return {
    reportList: [],
    userHpNo: "",
    acnoInfo: {},
    cusEkycParam: {}, // 생체정보 등록 데이터
    ppsnInfoGroupData: {}, //개인정보 데이터
    kycInfoGroupData: {}, //KYC정보그룹 데이터
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    //사고신고
    getReportList: state => {
      return state.reportList;
    },
    getUserHpNo: state => {
      return state.userHpNo;
    },

    getAcnoInfo: state => {
      return state.acnoInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    removeReportList: (state, index) => {
      state.reportList.splice(index, 1);
    },

    setUserHpNo: function (state, payload) {
      this._vm.$set(state.userHpNo, payload.key, payload.value);
    },
  },
  actions: {
    actResetState({ commit }) {
      commit("resetState");
    },
    actPersonalInfo: (context, payload) => context.commit("setPersonalInfo", payload),
    actClearPersonalInfo: context => context.commit("clearPersonalInfo"),
    actUserAuthorityManagementTransferDataEditUser: (context, payload) => context.commit("setUserAuthorityManagementTransferDataEditUser", payload),
    actPersonalInfoAuthenticationPrincipal: context => context.commit("clearPersonalInfoAuthenticationPrincipal"),
    actChangePasswordIsPwChngShow: (context, payload) => context.commit("setChangePasswordIsPwChngShow", payload),

    //사고신고
    actRemoveReportList: (context, payload) => {
      context.commit("removeReportList", payload);
    },
    actAddReportList: (context, payload) => {
      context.commit("addReportList", payload);
    },
  },
};
